import { BUSCAR_ENDERECO_POR_CEP, SELECIONAR_ENDERECO } from '../../actions/types'

const initialState = undefined;

export default function reducerEndereco (state = {}, action = initialState) {
  switch (action.type) {
    case BUSCAR_ENDERECO_POR_CEP: {
      return action.payload.data;
    }
    case SELECIONAR_ENDERECO: {
      return action.payload;
    }
    default: {
      return state
    }
  }
}
